const FLOOR_TYPES: string[] = ["Parking", "Basement", "Floor"];

export default FLOOR_TYPES;
